import { Hero } from '../components/Hero/Hero';
import { AboutUs } from '../components/AboutUs/AboutUs';
import { FeaturedProducts } from '../components/FeaturedProducts/FeaturedProducts';
import { QRCodeSection } from '../components/QRCodeSection/QRCodeSection';
import { Testimonials } from '../components/Testimonials/Testimonials';
import { TeamSection } from '../components/TeamSection/TeamSection';

/**
 * Home page — Yelp-style layout:
 * 1. Hero with search bar + category icons
 * 2. About Us with auto-rotating products
 * 3. Featured products (vertical list)
 * 4. QR Code section
 * 5. Recent reviews
 * 6. Meet the team
 */
export default function HomePage() {
  return (
    <main>
      <Hero />
      <AboutUs />
      <FeaturedProducts />
      <QRCodeSection />
      <Testimonials />
      <TeamSection />
    </main>
  );
}
